import React, { useState } from "react";
import { Modal, Button, Image, Col, Row, Form } from "react-bootstrap";
import { TextField, IconButton, FormControl, Select } from "@material-ui/core";
import en from "react-phone-number-input/locale/en.json";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { resetPassword } from "../../../../store/actions/AdminSms&Notification/message_notification";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";

const validationSchema = yup.object({
  password: yup
    .string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  passwordConfirmation: yup
    .string()

    .required("Confirm password is required")
    .oneOf([yup.ref("password"), null], "Password must match"),
});
export const CustomSuperAdminResetPassword = (props) => {
  //state

  const onSubmit = () => {
    const onSuccessResetPassword = () => {
      Alert.success(`<h4>Password Reset Successfully</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
      handleResetPassword();
    };
    const onErrorrResetPassword = () => {};
    let formData = {};

    if (props.mobileNo.startsWith("+91")) {
      formData.mobile_number = props.mobileNo.substring(3);
      formData.country_code = props.countryCode;
    } else {
      formData.mobile_number = props.mobileNo;
      formData.country_code = props.countryCode;
    }
    //formData.mobile_number = "+91" + props.mobileNo;
    formData._id = props.userId;
    props.resetPassword(
      formData,
      true,
      onSuccessResetPassword,
      onErrorrResetPassword
    );
  };

  const [showResetPassword, seShowResetPassword] = useState(false);
  const handleCloseResetPassword = () => {
    seResetPassword(false);
    seShowResetPassword(false);
  };
  const handleShowResetPassword = () => seShowResetPassword(true);
  const [ShowPassword, setShowPassword] = useState({ ShowPassword: false });
  const [ShowPassword2, setShowPassword2] = useState({ ShowPassword2: false });
  const [resetPassword, seResetPassword] = useState(false);
  const handleResetPassword = () => {
    seResetPassword(true);
  };
  const [state, setState] = useState({
    code: props.countryCode,
    // props.auth.user.VendorUser.country_code,
  });

  const handleChangeCode = (event) => {
    const code = event.target.name;
    setState({
      ...state,
      [code]: event.target.value,
    });
  };
  const handleClickShowPassword = (e) => {
    setShowPassword({
      ShowPassword: !ShowPassword.ShowPassword,
    });
  };
  const handleClickShowPassword2 = (e) => {
    setShowPassword2({
      ShowPassword2: !ShowPassword2.ShowPassword2,
    });
  };
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowResetPassword}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/ResetDrive.svg")}
          alt="Reset Password"
          title="Reset Password"
          fluid
        />
      </Button>
      <Modal
        show={showResetPassword}
        onHide={handleCloseResetPassword}
        centered
      >
        <Modal.Header className="py-0 pt-3 border-0" closeButton>
          <Modal.Title className="f16-500">Reset Password</Modal.Title>
        </Modal.Header>
        {!resetPassword && (
          <React.Fragment>
            <Form>
              {" "}
              <Modal.Body>
                <Row>
                  <Col xs={2} className="pr-0">
                    <Form.Group controlId={"country_code"}>
                      <FormControl variant="outlined" className="w-100">
                        <select
                          style={{
                            height: "48px",
                            borderRadius: "4px",
                            border: "1px solid #00000038",
                          }}
                          disabled={true}
                          className="w-100"
                          name="code"
                          value={state.code}
                          onChange={handleChangeCode}
                        >
                          <option value={state.code}>{state.code}</option>
                          {getCountries().map(
                            (country) => (
                              // state.code !==
                              // "+" + getCountryCallingCode(country) && (
                              <option
                                key={country}
                                value={"+" + getCountryCallingCode(country)}
                              >
                                {en[country]} (+{getCountryCallingCode(country)}
                                )
                              </option>
                            )
                            // )
                          )}
                        </select>
                        {/* <Select
                          disabled
                          value={state.code}
                          onChange={handleChangeCode}
                          inputProps={{
                            name: "code",
                          }}
                        >
                          <option value={state.country_code}>
                            {state.country_code}
                          </option>
                          {getCountries().map((country) => (
                            <option
                              key={country}
                              value={"+" + getCountryCallingCode(country)}
                            >
                              {en[country]} (+
                              {getCountryCallingCode(country)})
                            </option>
                          ))}
                        </Select> */}
                      </FormControl>
                    </Form.Group>
                  </Col>
                  <Col xs={10}>
                    <TextField
                      id="outlined-basic"
                      label="Phone Number"
                      variant="outlined"
                      className="w-100"
                      disabled
                      value={props.mobileNo}
                    />
                  </Col>
                  <Col xs={12}>
                    <div className="py-4">
                      <span className="f14-400">Name:</span>
                      <span className="f14-500">
                        {props.name} {"  "}
                        {props.lastName}
                      </span>
                    </div>
                  </Col>
                  {/* <Col xs={12} className="pt-2">
                    <Form.Group>
                      <TextField
                        id="enPassword"
                        label="Enter New Password"
                        variant="outlined"
                        type={ShowPassword.ShowPassword ? "text" : "password"}
                        className="enPassword w-100"
                        name="password"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.password}
                      />

                      <IconButton
                        className="enShowPasswordBtn"
                        onClick={handleClickShowPassword}
                        edge="end"
                      >
                        {ShowPassword.ShowPassword ? (
                          <Image
                            src={require("../../../../assets/images/UserManagement/view--on.svg")}
                            alt="View"
                            width="20px"
                            title="View"
                            fluid
                          />
                        ) : (
                          <Image
                            src={require("../../../../assets/images/UserManagement/view--off.svg")}
                            alt="View"
                            width="20px"
                            title="View"
                            fluid
                          />
                        )}
                      </IconButton>

                      {formik.errors.password && formik.touched.password ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.password}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col xs={12} className="pt-2">
                    <Form.Group>
                      <TextField
                        id="enPasswordConfirm"
                        label="Confirm New Password"
                        variant="outlined"
                        type={ShowPassword2.ShowPassword2 ? "text" : "password"}
                        className="enPassword w-100"
                        name="passwordConfirmation"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.passwordConfirmation}
                      />
                      <IconButton
                        className="enShowPasswordBtn"
                        onClick={handleClickShowPassword2}
                        edge="end"
                      >
                        {ShowPassword2.ShowPassword2 ? (
                          <Image
                            src={require("../../../../assets/images/UserManagement/view--on.svg")}
                            alt="View"
                            width="20px"
                            title="View"
                            fluid
                          />
                        ) : (
                          <Image
                            src={require("../../../../assets/images/UserManagement/view--off.svg")}
                            alt="View"
                            width="20px"
                            title="View"
                            fluid
                          />
                        )}
                      </IconButton>
                      {formik.errors.passwordConfirmation &&
                      formik.touched.passwordConfirmation ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.passwordConfirmation}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                 */}
                </Row>
              </Modal.Body>
              <Modal.Footer className="justify-content-start border-0">
                <Button
                  variant="outline-secondary"
                  className="btn-lg mr-4 px-4"
                  onClick={handleCloseResetPassword}
                >
                  Cancel
                </Button>
                <Button
                  variant="danger"
                  className="btn-lg px-4"
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Form>
          </React.Fragment>
        )}
        {resetPassword && (
          <Modal.Body>
            <Image
              src={require("../../../../assets/images/UserManagement/checked.svg")}
              alt="View"
              title="View"
              fluid
              className="enResetPaaswordChecked"
            />
            <div className="f17-500 mt-4 mb-2">
              Your password was successfully reset
            </div>
            <div className="f13-400 mb-4">
              An email and SMS was sent to the user about the password change
              and new password was sent
            </div>
            <Button
              variant="danger"
              className="btn-lg px-4"
              onClick={handleCloseResetPassword}
            >
              Okay
            </Button>
          </Modal.Body>
        )}
      </Modal>
    </React.Fragment>
  );
};

CustomSuperAdminResetPassword.propTypes = {
  auth: PropTypes.object.isRequired,
  resetPassword: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { resetPassword })(
  CustomSuperAdminResetPassword
);
